// extracted by mini-css-extract-plugin
export default {"spare_part_section":"sparePartsCardSection_spare_part_section__nCSfk","card_container":"sparePartsCardSection_card_container__aw8sM"};